import { Navigate, Outlet } from 'react-router-dom';

import { useProfileInstitutionDetailsAnswers, useProfileInstitutionDetailsDraft, useProfileInstitutionDetailsVersion } from '@/hooks/queries/use-profile-institution-details';
import LoadingPage from '@/pages/loading';
import { INSTITUTION_DETAILS_VERSION } from '@/services/api/profile';

// An unfinished application on an older version carries on in the update flow, while a complete one stays valid on its version
const InstitutionOnboardingUnfinishedGuard = () => {
  const { isLoading: isLoadingInstitutionDetailsAnswers, isCompleteOnboarding: isCompleteInstitutionDetailsOnboarding } = useProfileInstitutionDetailsAnswers();
  const { data: version } = useProfileInstitutionDetailsVersion();
  const isUnfinishedOnOlderVersion = isCompleteInstitutionDetailsOnboarding === false && version === INSTITUTION_DETAILS_VERSION.V1;
  const { isLoading: isLoadingDraft, data: draft } = useProfileInstitutionDetailsDraft(isUnfinishedOnOlderVersion);
  const isLoading = isLoadingInstitutionDetailsAnswers || isLoadingDraft;
  const isUpdateApplicable = isUnfinishedOnOlderVersion && !!draft;

  if (isLoading) return <LoadingPage />;

  if (isUpdateApplicable) return <Navigate to="/institution/onboarding/update" replace />;

  return <Outlet />;
};
InstitutionOnboardingUnfinishedGuard.displayName = 'InstitutionOnboardingUnfinishedGuard';

export default InstitutionOnboardingUnfinishedGuard;
